<template>
  <div class="oilHistory">
    <div class='wrapHeader'>
      <el-form :inline="true" :model="selectLog" class="demo-form-inline">
        <el-form-item label="仓房选择">
          <el-select v-model="selectLog.wareId" clearable placeholder="仓房选择" @change='conditionChange'>
            <el-option :label="item.wareName" :value="item.wareId" v-for='item in wareList' :key='item.wareId'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="selectLog.beginTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="startPickerOpts"
            @change='conditionChange'
            placeholder="开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="selectLog.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="endPickerOpts"
            @change='conditionChange'
            placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="setBgImg" :style="`height:${height}px`">
      <div class="showView" :style="`height:${height-20}px;width:${width-30}px`">
        <div class="setTabView" :style='`height:${height-50}px;width:${width-60}px`'>
          <div class="oilList" :style="`height:${height-50}px`">
            <el-table
              :data="tableData"
              style="width: 100%"
              :header-cell-style='{"background":"rgba(48,56,255,0.03)"}'
              :max-height="height-105"
              id="table"
              border>
              <el-table-column 
                type="index" 
                width="60" 
                align='center' 
                label="序号" 
                :index="indexMethod">
              </el-table-column>
              <el-table-column 
                prop="wareName" 
                label="仓房名称" 
                align="center" 
                min-width='100'>
              </el-table-column>
              <el-table-column
                prop="tempMax"
                label="最高温(℃)"
                align="center"
                min-width='90'
              >
              </el-table-column>
              <el-table-column
                prop="tempMin"
                label="最低温(℃)"
                align="center"
                min-width='90'
              >
              </el-table-column>
              <el-table-column
                prop="tempAve"
                label="平均温(℃)"
                align="center"
                min-width='90'
              >
              </el-table-column>
              <el-table-column
                prop="bitHeight"
                label="油位高(m)"
                align="center"
                min-width='90'
              >
              </el-table-column>
              <el-table-column
                align='center' 
                label="层温度(℃)">
                <el-table-column
                  align='center' 
                  :label="'第'+item+'层'"
                  :min-width='maxNum==1?160:(maxNum==2?90:60)'
                  v-for='item in maxNum' :key='item'>
                  <template slot-scope="scope">
                    <span>{{scope.row.details.length>=item?scope.row.details[item-1].temp:''}}</span>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="采集时间"
                align="center"
                min-width='140'
                fixed='right'
              >
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              :hide-on-single-page='true'
              :pageSize='selectLog.pageSize' 
              :current-page='selectLog.pageNum'
              @current-change='getOtherLog'
              class='setPosition'>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      selectLog:{
        pageNum:1,
        pageSize:17,
        orderByColumn:'leakCheckId',
        isAsc:'desc',
        wareId:'',
      },
      wareList:[],
      tableData:[],
      total:0,
      maxNum:0,
      startPickerOpts:{
        disabledDate:(t)=>{
          return this.selectLog.endTime?t.getTime()>new Date(this.selectLog.endTime).getTime():false
        }
      },
      endPickerOpts:{
        disabledDate:(t)=>{
          return this.selectLog.beginTime?t.getTime()<new Date(this.selectLog.beginTime).getTime():false
        }
      }
    }
  },
  created(){
    this.getWareList();
    this.getselectInfo()
  },
  methods:{
   getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data
        }
      })
    },
    getselectInfo(){
      axios.get('/system/leakCheck/list',{params:this.selectLog}).then(res=>{
        if(res.code==200){
          let data=res.rows;
          let max=0;
          data.forEach(item=>{
            if(max<item.details.length){
              max=item.details.length
            }
          })
          this.maxNum=max;
          this.tableData=data;
          this.total=res.total
        }
      })
    },
    conditionChange(){
      this.selectLog.pageNum=1
      this.getselectInfo()
    },
    getOtherLog(val){
      this.selectLog.pageNum=val
      this.getselectInfo()
    },
    indexMethod(index){
      return (this.selectLog.pageNum-1)*this.selectLog.pageSize+index+1
    }
  }
}
</script>

<style lang="scss" scoped>
  .oilHistory{
    .oilList{
      border: 1px solid #e4e7ed;
      padding: 10px;
      box-sizing: border-box;
      overflow: auto
    }
  }
</style>

